module.exports = "/images/avatar-s-14.jpg?c352e978077fc0ae4bf572a2a92d497e";